import assignAgentToClient from 'resources/client/workflows/assignAgentToClient';
import dealService from 'resources/deal/deal.service';

import * as userOperations from 'resources/user/user.operations';

const updateDealClients = async ({
  clientIds,
  deal,
}) => {
  await dealService.updateOne({ id: deal.id }, { client_ids: clientIds });

  const promises = clientIds.map((clientId) => assignAgentToClient(clientId, deal.realtor_id));

  await Promise.all(promises);

  // to set roles and status to client according to deal
  const updatedClients = await Promise.all(clientIds.map(async (id) => (
    userOperations.actualizeClientStatusAndRoles(id)
  )));

  return updatedClients;
};

export {
  updateDealClients,
};
